import { render } from "./PropertiesComponent.vue?vue&type=template&id=edb587f2"
import script from "./PropertiesComponent.vue?vue&type=script&lang=js"
export * from "./PropertiesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__